module.exports = __webpack_public_path__ + "static/media/avatar_penguin.f76c59c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_penguin.png
// module id = 393
// module chunks = 0